import { render, staticRenderFns } from "./StackedReviewCarousel.vue?vue&type=template&id=c0526be2"
import script from "./StackedReviewCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./StackedReviewCarousel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports